import React, { useState, useEffect } from 'react';
import {
    E,
    usePortfolio,
    useUser,
    useQuotes,
    userManager,
    wsClient
} from '../../logic/imports';
import * as Common from '../app/CommonComps';
import { showDimmer } from '../app/Dimmer';

export const HeaderPanel: React.FC = () => {
    const { balances } = usePortfolio();
    const { userData, userPrefs } = useUser();
    const { quotes, requestQuote, releaseQuote } = useQuotes();

    const [spyPrice, setSpyPrice] = useState<number | null>(null);
    const [hasAlertsGrant, setHasAlertsGrant] = useState(false);
    const [discordEnabled, setDiscordEnabled] = useState(false);

    // Check if user has DISCORD_ALERTS grant
    
    // On mount, Subscribe to SPY quote and check grants. On unmount, undo.
    useEffect(() => {
        const canAlert = userData?.grants.includes(E.Grant.DISCORD_ALERTS) || false;
        setHasAlertsGrant(canAlert);
        setDiscordEnabled(userPrefs?.miscPrefs.discordAlertsEnabled ?? false);

        const subId = crypto.randomUUID().substring(0, 3);
        requestQuote('SPY', `HeaderPanel-${subId}`);

        return () => {
            releaseQuote('SPY', `HeaderPanel-${subId}`);
        };
    }, [userData, userPrefs]);

    // Maintain current SPY price
    useEffect(() => {
        const spyQuote = quotes.find(q => q.instrument.symbol === 'SPY');
        if (spyQuote?.last) {
            setSpyPrice(spyQuote.last);
        }
    }, [quotes]);

    const onDiscordToggleClicked = async () => {
        try {
            const newState = await wsClient.sendRequest(
                E.WsRoute.SYS,
                E.WsSysCommand.DISCORD_TOGGLE_ALERTS,
                !discordEnabled
            );

            setDiscordEnabled(newState);
            // Persist to user preferences
            userManager.setDiscordToggle(newState);
        } catch (error: any) {
            showDimmer('Error toggling Discord alerts: ' + error.message, true);
        }
    }

    const discordToggle = (
        <button
            className={`iconBtn iconBtn--Discord` + 
                (discordEnabled ? ' iconBtn--Discord-active' : '')
            }
            onClick={() => onDiscordToggleClicked()}
        />
    )

    return (
        <div className="panel">
            {/* <div className="panel-header"> </div> */}
            
            {/* SPY Quote */}
            {/* <Common.KeyValueDisplay
                name="SPY Price"
                value={spyPrice ?? '- - - - -'}
                numericValueFormat="dollars"
                forceCents={true}
            /> */}

            {/* Buying Power */}
            <Common.KeyValueDisplay
                name="Buying Power"
                value={balances?.cashSettled ?? '- - - - -'}
                numericValueFormat="dollars"
            />

            {hasAlertsGrant && discordToggle}
        </div>
    )
}
